import React from 'react'
import { Stack, Typography } from '@mui/material'
import { OAuthIntegrationConnectedCard } from '../oauth-integration-connected-card/oauth-integration-connected-card'
import { IframeLink } from '../../iframe-link'
import { appendJDLinkToHeapLocation, trackAnalyticEvent, ANALYTICS_LOCATIONS } from '../../../utils'
import { HelpUrl } from '../../../graphql'
import { getHelpUrl, T3_HELP_URL_KEY } from '../../../utils/urls'
import { ContentBox, StyledBadge, StyledButton, StyledCard, StyledContentTypography } from './oauth-integration-card.styles'

export type OAuthIntegrationCardProps = {
	isConnecting?: boolean,
	isFullyConnected: boolean,
	isPartiallyConnected: boolean,
	integrationName: string,
	helpUrls: HelpUrl[] | undefined,
	onPress: () => void,
	buttonText: string,
	isEditing: boolean,
}

export const OAuthIntegrationCard: React.FC<OAuthIntegrationCardProps> = ( {
	isConnecting,
	isFullyConnected,
	isPartiallyConnected,
	integrationName,
	helpUrls,
	onPress,
	buttonText,
	isEditing = false,
} ) => {
	if ( isFullyConnected || isPartiallyConnected ) {
		return <OAuthIntegrationConnectedCard title={`Connected to ${integrationName}`} />
	}
	const learnMoreUrl = getHelpUrl( T3_HELP_URL_KEY, helpUrls )

	return (
		<StyledCard>
			<Stack direction="row" spacing={2} alignItems="flex-start">
				<StyledBadge
					color="primary"
					badgeContent={1}
					style={{ marginTop: '12px', marginLeft: '14px', marginRight: '5px' }}
				/>
				<ContentBox>
					<StyledContentTypography variant="h4">
						Connect to {integrationName}
					</StyledContentTypography>
					<StyledContentTypography color="textSecondary">
						Log in to {integrationName} below using your credentials, then come back to this page.
						{learnMoreUrl &&
						<>&nbsp;
							<IframeLink
								onClick={() => {
									trackAnalyticEvent(
										ANALYTICS_LOCATIONS.CREATE_PAGE,
										'Click',
										appendJDLinkToHeapLocation( 'Don\'t have credentials?', integrationName || '' ),
									)
								}}
								href={learnMoreUrl}
								target="_blank"
							>
							Don&apos;t have credentials?
							</IframeLink>
						</>}
					</StyledContentTypography>
					<StyledButton
						variant={isEditing ? 'outlined' : 'contained'}
						color="primary"
						size="small"
						onClick={() => {
							trackAnalyticEvent(
								ANALYTICS_LOCATIONS.CREATE_PAGE,
								'Click',
								appendJDLinkToHeapLocation( buttonText, integrationName || '' ),
							)
							onPress()
						}}
						disabled={isConnecting}
						loading={isConnecting}
					>
						<Typography fontSize={14}>
							{buttonText}
						</Typography>
					</StyledButton>
				</ContentBox>
			</Stack>
		</StyledCard>
	)
}
